import type { DefaultOptions } from '@tanstack/react-query'

export const queryConfig = {
  queries: {
    refetchOnWindowFocus: false,
    retry: 0,
    staleTime: 1000 * 60 * 5, // 5 minutes
  },
} satisfies DefaultOptions
